/**
 * Custom polyfills for browser-only globals needed by third-party libraries.
 */
(function applyGlobalPolyfills() {
  if (typeof window === 'undefined') {
    return;
  }
  const win = window as typeof window & { global?: typeof window; process?: any };
  if (!win.global) {
    win.global = win;
  }
  if (!win.process) {
    win.process = { env: {} };
  }
})();
